module.exports = __webpack_public_path__ + "assets/img/level2.6bafdfb9.png";